import axios from 'axios';

import routes from 'app/routes';

export default {
  switch: (enterpriseId, callback) => {
    axios
      .post(routes.api.users.enterprises.switch(enterpriseId))
      .then((_resp) => {
        callback();
      });
  },
};
